import React, { useEffect } from 'react';
import { isMobileScreen } from '@apply/ui';
import { Menu, MenuItem } from '@apply/components';
import { ProfileButton } from './ProfileButton/ProfileButton';
import { LogoLink } from '../../../common/components/LogoLink';
import store from '@apply/adminStore';

const mobileScreen = isMobileScreen();

export enum MenuItemOption {
    NoOptionSelected = 0,
    Home = 1,
    Settings = 2,
    ReviewAccountInfo = 3,
    SignUserAgreement = 4,
}

export const Header: React.FC<{ printMode?: boolean; activeMenuItem?: MenuItemOption }> = ({
    printMode,
    activeMenuItem = MenuItemOption.NoOptionSelected,
}) => {
    const { user } = store.getState();

    useEffect(() => {
        if (!user || !user.isBroker) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [user]);

    const nonAcceptedTermsMenuItems = () => {
        return (
            <>
                <MenuItem
                    active={activeMenuItem == MenuItemOption.ReviewAccountInfo}
                    hint='Review Account Information'
                    url='/brokeraccount'
                >
                    Review Account Information
                </MenuItem>
            </>
        );
    };

    const acceptedTermsMenuItems = () => {
        return (
            <>
                <MenuItem
                    active={activeMenuItem == MenuItemOption.Home}
                    hint='BFI Apply Home Page'
                    url='/referrals'
                >
                    Referrals
                </MenuItem>
                <MenuItem
                    active={activeMenuItem == MenuItemOption.Settings}
                    hint='BFI Broker Settings'
                    url='/settings'
                >
                    Settings
                </MenuItem>
            </>
        );
    };

    const requiresESignMenuItems = () => {
        return (
            <>
                <MenuItem
                    active={activeMenuItem == MenuItemOption.SignUserAgreement}
                    hint='Sign User Agreement'
                    url='/broker/signagreement'
                >
                    User Agreement
                </MenuItem>
            </>
        );
    };

    const menuItems = () => {
        if (user.requiresESign) {
            return requiresESignMenuItems();
        }
        if (user.isBroker) {
            return user.areTermsAccepted ? acceptedTermsMenuItems() : nonAcceptedTermsMenuItems();
        }

        return null;
    };

    return (
        <>
            <header>
                <div
                    className='headerWrapper'
                    style={{
                        visibility: user.isBroker ? 'visible' : 'hidden',
                    }}
                >
                    <div className='logoWrapper'>
                        <LogoLink />
                    </div>
                    <div className='menuWrapper'>{!mobileScreen && menuItems()}</div>
                    <div className={`${printMode ? 'hidden' : 'headerNav'}`}>
                        <div className='headerNav-navItem'>
                            <ProfileButton printMode={printMode} />
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};
